import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from "./_components/loader/loader.component";
import { SideNavigationComponent } from "./_components/side-navigation/side-navigation.component";
import { HeaderComponent } from "./_components/header/header.component";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ConfirmationModalComponent } from "./_components/confirmation-modal/confirmation-modal.component";
import { FileSizePipe } from "./_pipes/file-size.pipe";
import { NoDataComponent } from "./_components/no-data/no-data.component";
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { ResourceDetailsModalComponent } from './_components/resource-details-modal/resource-details-modal.component';

@NgModule({
    declarations: [
        LoaderComponent,
        SideNavigationComponent,
        HeaderComponent,
        ConfirmationModalComponent,
        ResourceDetailsModalComponent,
        FileSizePipe,
        NoDataComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatSidenavModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatMenuModule,
        MatRadioModule
    ],
    exports: [
        LoaderComponent,
        SideNavigationComponent,
        HeaderComponent,
        ConfirmationModalComponent,
        ResourceDetailsModalComponent,
        FileSizePipe,
        NoDataComponent,
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' }
        }
    ]
})
export class SharedModule {

}
